import { keyframes, Theme } from '@mui/material/styles';

export const gradient = (theme: Theme) =>
  `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`;

// Bubbles follow the theme radius, with a tighter corner on the speaker's side.
export const bubbleRadius = (theme: Theme, isUser: boolean) => {
  const r = theme.shape.borderRadius;
  return isUser ? `${r}px ${r}px 3px ${r}px` : `${r}px ${r}px ${r}px 3px`;
};

export const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.55); }
  70% { box-shadow: 0 0 0 16px rgba(13, 148, 136, 0); }
  100% { box-shadow: 0 0 0 0 rgba(13, 148, 136, 0); }
`;

export const slideIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-4px); opacity: 1; }
`;
